<template>
  <div class="login-box well white-box">

    <logo-component></logo-component>
    <div class="alert alert-success" v-if="verify_mail_success">
      <p>Successful activation. You can log in with your credentials.</p>
    </div>
    <div class="alert alert-success" v-if="mail_sended">
      <p>An email was sent to {{ email }}. Please check your inbox or spam folder.</p>
    </div>
    <div class="alert alert-danger" v-if="error">
      <p>{{ error_message }}</p>
    </div>
    <b-form @submit.prevent="onSubmit">
      <b-form-group
          label="Email:"
          label-for="email">
        <b-form-input
            name="email"
            id="email"
            v-model="email"
            type="text"
            v-validate="{ required:true }"
            :state="errors.has('email') ? false : null"
            placeholder="user@example.com">
        </b-form-input>
        <em v-if="errors.has('email')" class="text-danger">
          {{ errors.first('email') }}
        </em>
      </b-form-group>
      <b-form-group
          label="Password:"
          label-for="password"
          class="mb-4">
        <b-form-input
            name="password"
            id="password"
            v-model="password"
            type="password"
            v-validate="{ required:true }"
            :state="errors.has('password') ? false : null"
            placeholder="Enter your password">
        </b-form-input>
        <em v-if="errors.has('password')" class="text-danger">
          {{ errors.first('password') }}
        </em>
        <router-link :to="{name : 'password.recover'}" replace exact>
          <a class="recover-pass">Forgot my password</a>
        </router-link>
      </b-form-group>
      <b-form-group class="d-none">
        <b-form-checkbox
            v-model="rememberMe"
            value="true"
            size="md"
            unchecked-value="false">
          Remember Me
        </b-form-checkbox>
      </b-form-group>

      <div class="mb-3">
        <b-button type="submit" variant="primary"
                  :disabled="loading"
                  class="mr-2">
          <span>Sign in</span>
          <b-spinner
              v-if="loading"
              small
              class="ml-2"/>
        </b-button>

        <router-link :to="{name : 'register'}" replace exact>
          <a> Or register</a>
        </router-link>
      </div>

    </b-form>
  </div>
</template>

<script>
import LogoComponent from './Logo.vue';

export default {
  components: {
    LogoComponent
  },
  $_veeValidate: {
    validator: 'new'
  },
  props: ['report_id', 'user_id', 'mail_token'],
  data() {
    return {
      email: null,
      password: null,
      error: false,
      error_message: '',
      verify_mail_success: false,
      mail_sended: false,
      rememberMe: true,
      loading: false
    }
  },
  created() {
    if (this.user_id && this.mail_token) {
      axios.post('/users/activate/' + this.user_id + '/' + this.mail_token)
          .then(res => {
            this.verify_mail_success = true;
          })
          .catch((error) => {
            this.error = true;
            this.error_message = error.response.data.message;
          })
    }
  },
  mounted() {
    $('html').addClass('login');
  },
  methods: {
    onSubmit() {

      var app = this;
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.loading = true;
          this.$auth.login({
            data: {
              email: app.email,
              password: app.password,
            },
            url: 'login',
            redirect: {
              name: this.report_id ? 'report.show' : 'welcome',
              params: this.report_id ? {report_id: this.report_id} : null
            },
            success: function () {
              this.loading = false;
              $('html').removeClass('login');
              this.$router.replace({name: 'welcome'});
            },
            error: (resp) => {
              this.loading = false;
              app.error = true;
              app.error_message = resp.response.data.message;
              app.mail_sended = resp.response.data.data.mail_sended;
            },
            rememberMe: Boolean(this.rememberMe),
            fetchUser: false
          });
        }
      });
    },
    redirect() {
      this.$router.replace({name: 'register'})
    }
  }
}
</script>

<style scoped>
.center-div {
  margin: 0 auto;
  width: 800px;
}

.recover-pass {
  float: right;
  font-size: 13px;
  padding: 5px 0px;
}
</style>
